import { PlasticsCalendarEventType } from "../enums/plastics-calendar-event-type.enum";

export interface PlasticsCalendarEvent {
    id: string;
    eventDate: Date;
    eventTimeSet: boolean;
    title: string;
    type: PlasticsCalendarEventType;
    notes: string;
}

export const DEFAULT_PLASTICS_CALENDAR_EVENT: PlasticsCalendarEvent = {
    id: '',
    eventDate: new Date,
    eventTimeSet: false,
    title: '',
    type: null as unknown as PlasticsCalendarEventType,
    notes: '',
}